import moment, { Moment } from 'moment'
import { DATE_FORMATS, RANGE_SEPARATOR } from '../constants/constants'

/**
 * Форматирует дату для отображения в инпуте
 * Если дата - сегодня, показывает "Сегодня, DD.MM.YYYY"
 * Если дата - вчера, показывает "Вчера, DD.MM.YYYY"
 * Иначе показывает "DD.MM.YYYY"
 */
export const formatDateForInput = (date: Moment | null): string => {
	if (!date || !date.isValid()) {
		return ''
	}

	const now = moment()
	const yesterday = moment().subtract(1, 'day')

	if (date.isSame(now, 'day')) {
		return date.format(DATE_FORMATS.TODAY)
	}

	if (date.isSame(yesterday, 'day')) {
		return date.format(DATE_FORMATS.YESTERDAY)
	}

	return date.format(DATE_FORMATS.DISPLAY)
}

/**
 * Форматирует диапазон дат для отображения в инпуте
 * Формат: "DD.MM.YY — DD.MM.YY"
 */
export const formatDateRangeForInput = (
	startDate: Moment | null,
	endDate: Moment | null,
): string => {
	if (!startDate || !startDate.isValid() || !endDate || !endDate.isValid()) {
		return ''
	}

	const start = startDate.format(DATE_FORMATS.SHORT)
	const end = endDate.format(DATE_FORMATS.SHORT)

	return `${start} ${RANGE_SEPARATOR} ${end}`
}

/**
 * Получает формат даты в зависимости от того, сегодня ли это или вчера
 */
export const getDateFormat = (date: Moment | null): string => {
	if (!date || !date.isValid()) {
		return DATE_FORMATS.DISPLAY
	}

	const now = moment()
	const yesterday = moment().subtract(1, 'day')

	if (date.isSame(now, 'day')) {
		return DATE_FORMATS.TODAY
	}

	if (date.isSame(yesterday, 'day')) {
		return DATE_FORMATS.YESTERDAY
	}

	return DATE_FORMATS.DISPLAY
}

/**
 * Парсит строку даты в Moment объект
 */
export const parseDate = (dateString: string): Moment | null => {
	const parsed = moment(dateString, DATE_FORMATS.DISPLAY, true)
	return parsed.isValid() ? parsed : null
}

/**
 * Форматирует месяц и год для отображения в шапке календаря
 * Формат: "Декабрь 2025"
 */
export const formatMonthYear = (date: Moment): string => {
	return date.format('MMMM YYYY')
}

/**
 * Форматирует только год
 */
export const formatYear = (date: Moment): string => {
	return date.format('YYYY')
}

/**
 * Форматирует только месяц
 */
export const formatMonth = (date: Moment): string => {
	return date.format('MMMM')
}
